export { BagStripe } from './BagStripe';
export { BagStripeOpacityAnimation } from './BagStripeOpacityAnimation';
